import React from 'react'
import cn from 'classnames'
import { useStoreon } from 'storeon/react'
import { Events, State } from '@/interfaces'
import { TYPES_ORDER } from '../../../../const'
import { ISelectType } from '../../interfaces'
import { TYPES_PIPE_OR_WAVE } from '../../consts'
import style from './styles/index.module.scss'

const SelectType: React.FC<ISelectType> = ({ type, setType }) => {
  const { dispatch } = useStoreon<State, Events>('statusGetOrders')
  const types = [
    {
      title: 'Труба',
      id: 1,
      value: TYPES_PIPE_OR_WAVE.PIPE
    },
    {
      title: 'Волна',
      id: 2,
      value: TYPES_PIPE_OR_WAVE.WAVE
    }
  ]

  const handleClick = (e: React.SyntheticEvent<EventTarget, MouseEvent>) => {
    if (e.target instanceof HTMLElement) {
      const { value = '' } = e.target.dataset
      dispatch('typeOrder/set', TYPES_ORDER[value])
      dispatch('orders/get')
      dispatch('flagOrArray/clear')
      setType(value as TYPES_PIPE_OR_WAVE)
    }
  }

  return (
    <div className={style.select_wrapper}>
      {types.map((el) => {
        return (
          <div
            key={el.id}
            role='button'
            className={cn({
              [style['select_wrapper__item']]: true,
              [style['select_wrapper__item--active']]: el.value === type,
              [style['select_wrapper__item--active_wave']]: type === TYPES_PIPE_OR_WAVE.WAVE
            })}
            data-value={el.value}
            tabIndex={el.id}
            onClick={handleClick}
          >
            {el.title}
          </div>
        )
      })}
    </div>
  )
}

export default SelectType
